import { useEffect, useRef, useState } from 'react'
import { motion } from 'framer-motion'
import Header from '../components/Header'

// daily-checkin v2 — vitais (humor/energia/sono/exercício) + relato + treino ESTRUTURADO + PR.
// Grava em diario_humor + diario_entradas + ares_treinos (exercicios jsonb) + ares_marcos.
// Mesma tabela cloud (jwugagzmhkfoxypfnlor) que o ARES lê → fonte única. Template = treino-atual.md.
const CHECKIN_TOKEN = 'eod-k7m2x9'

const TREINO_TIPOS = ['A', 'B', 'C', 'deload', 'karate', 'cardio', 'livre']
const STRENGTH = new Set(['A', 'B', 'C', 'deload']) // tipos que carregam exercícios estruturados
const PR_TIPOS = ['1RM', '3RM', '5RM', '8RM']

// Template por tipo (fonte: treino-atual.md, sync 2026-07-14). Matheus só bate carga/reps/rpe feitos.
type TplEx = { nome: string; series: string; reps: string; rpe: string }
const TREINO_TEMPLATES: Record<string, TplEx[]> = {
  A: [
    { nome: 'Box Jump / Plyo Push-up', series: '4', reps: '3-5', rpe: '' },
    { nome: 'Agachamento com barra', series: '4', reps: '6-8', rpe: '8' },
    { nome: 'Leg Press', series: '3', reps: '10-12', rpe: '8' },
    { nome: 'Supino com halteres', series: '3', reps: '8-10', rpe: '8' },
    { nome: 'Desenvolvimento militar halteres', series: '3', reps: '8-10', rpe: '8' },
    { nome: 'Crunch com anilha (abdômen)', series: '3', reps: '12-15', rpe: '8' },
  ],
  B: [
    { nome: 'Broad Jump / Med Ball Slams', series: '4', reps: '3-4', rpe: '' },
    { nome: 'Terra Romeno', series: '4', reps: '8-10', rpe: '8' },
    { nome: 'Barra fixa / Puxada', series: '3', reps: '8-10', rpe: '8' },
    { nome: 'Leg Curl', series: '3', reps: '12-15', rpe: '8' },
    { nome: 'Remada curvada', series: '3', reps: '10-12', rpe: '8' },
    { nome: 'Abdominal russo com peso', series: '3', reps: '15/lado', rpe: '8' },
  ],
  C: [
    { nome: 'Skater Jumps', series: '3', reps: '4-5/lado', rpe: '' },
    { nome: 'Med Ball Rotacional', series: '3', reps: '5/lado', rpe: '' },
    { nome: 'Elevação lateral', series: '4', reps: '12-15', rpe: '9' },
    { nome: 'Rosca direta halter/polia', series: '3', reps: '8-12', rpe: '8' },
    { nome: 'Tríceps corda', series: '3', reps: '12-15', rpe: '8' },
    { nome: 'Voador invertido (máquina)', series: '3', reps: '12-15', rpe: '8' },
    { nome: 'Woodchopper cabo', series: '3', reps: '12-15/lado', rpe: '' },
    { nome: 'Pallof press', series: '3', reps: '10/lado', rpe: '' },
  ],
  deload: [],
}

interface Humor { data: string; nivel: number | null; energia: number | null; sono_horas: number | null; exercicio_horas: number | null; nota: string | null; created_at: string }
interface Entrada { data: string; relato: string; alimentacao: string | null; acao_do_dia: string | null; ancora: string | null; created_at: string }
interface ExJson { nome: string; series: number | null; reps: string | null; carga_kg: number | null; rpe: number | null }
interface TreinoRow { id: string; data: string; dia_tipo: string | null; bloco_semana: number | null; semana_num: number | null; exercicios: ExJson[] | null; rpe_medio: number | null; volume_total: number | null; calorias: number | null; observacoes: string | null; created_at: string }
interface Marco { data: string; exercicio: string; tipo: string; valor: number; unidade: string | null; contexto: string | null; created_at: string }

// estado editável do form
interface ExRow { nome: string; series: string; reps: string; carga_kg: string; rpe: string }
interface Sessao { id?: string; dia_tipo: string; exercicios: ExRow[]; obs: string; calorias: string }

const fade = (delay = 0) => ({ initial: { opacity: 0, y: 16 }, animate: { opacity: 1, y: 0 }, transition: { duration: 0.4, delay } })

function todayStr() {
  const d = new Date() // data LOCAL (não UTC) — evita rolar pro dia seguinte à noite no Brasil (UTC-3)
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
}
function shiftDay(d: string, n: number) { const dt = new Date(d + 'T12:00:00'); dt.setDate(dt.getDate() + n); return dt.toISOString().slice(0, 10) }
function fmtDay(d: string) {
  const dt = new Date(d + 'T12:00:00')
  const dia = ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'][dt.getDay()]
  return `${dia} ${String(dt.getDate()).padStart(2, '0')}/${String(dt.getMonth() + 1).padStart(2, '0')}`
}
function num(v: string): number | null { const n = parseFloat(v); return isNaN(n) ? null : n }
function repsLow(reps: string): number | null { const m = String(reps).match(/\d+/); return m ? parseInt(m[0]) : null }
function blankEx(): ExRow { return { nome: '', series: '', reps: '', carga_kg: '', rpe: '' } }
function tplRows(tipo: string): ExRow[] {
  const tpl = TREINO_TEMPLATES[tipo]
  if (!tpl || !tpl.length) return [blankEx()]
  return tpl.map(e => ({ nome: e.nome, series: e.series, reps: e.reps, carga_kg: '', rpe: e.rpe }))
}
function sessaoMetrics(ex: ExRow[]) {
  const rpes = ex.map(e => num(e.rpe)).filter((n): n is number => n != null)
  const rpe_medio = rpes.length ? Math.round((rpes.reduce((a, b) => a + b, 0) / rpes.length) * 10) / 10 : null
  let vol = 0
  ex.forEach(e => { const s = num(e.series) || 0, r = repsLow(e.reps) || 0, c = num(e.carga_kg) || 0; vol += s * r * c })
  return { rpe_medio, volume_total: vol > 0 ? vol : null }
}
function fmtTreino(t: TreinoRow): string {
  const exs = (t.exercicios || []).map(e => {
    const carga = e.carga_kg != null ? `${e.carga_kg}kg ` : ''
    const sr = e.series != null && e.reps ? `${e.series}×${e.reps}` : (e.reps || '')
    return `${e.nome} ${carga}${sr}`.trim()
  })
  return exs.length ? exs.join(' · ') : (t.observacoes || '')
}

// ── persistência local ──
// 1) cache do histórico → render instantâneo no 1º paint (igual /stats).
// 2) rascunho por dia → o relato/vitais que você começou a escrever sobrevivem a fechar a aba sem salvar.
const CK_CACHE = 'ck_cache_v1'
function readCkCache(): { humor?: Humor[]; entradas?: Entrada[]; treinos?: TreinoRow[]; marcos?: Marco[] } | null {
  try { return JSON.parse(localStorage.getItem(CK_CACHE) || 'null') } catch { return null }
}
function writeCkCache(d: unknown) { try { localStorage.setItem(CK_CACHE, JSON.stringify(d)) } catch { /* quota */ } }

type Snap = {
  nivel: number | null; energia: number | null; sono: string; exercicio: string; nota: string
  relato: string; alimentacao: string; acao: string; ancora: string
  // treino/PR em montagem: só rascunho local (não vêm do servidor, que é append por dia_tipo)
  bloco: string; semana: string; sessoes: Sessao[]
  prOpen: boolean; prEx: string; prTipo: string; prValor: string; prCtx: string
}
const BLANK_SNAP: Snap = { nivel: null, energia: null, sono: '', exercicio: '', nota: '', relato: '', alimentacao: '', acao: '', ancora: '', bloco: '', semana: '', sessoes: [], prOpen: false, prEx: '', prTipo: '1RM', prValor: '', prCtx: '' }
function draftKey(d: string) { return 'ck_draft_' + d }
// merge com BLANK_SNAP: rascunhos antigos (sem campos de treino) não quebram o shape.
function readDraft(d: string): Snap | null { try { const s = JSON.parse(localStorage.getItem(draftKey(d)) || 'null'); return s ? { ...BLANK_SNAP, ...s } : null } catch { return null } }
function writeDraft(d: string, s: Snap) { try { localStorage.setItem(draftKey(d), JSON.stringify(s)) } catch { /* quota */ } }
function clearDraft(d: string) { try { localStorage.removeItem(draftKey(d)) } catch { /* noop */ } }
function snapBlank(s: Snap) { return s.nivel == null && s.energia == null && !s.sono && !s.exercicio && !s.nota && !s.relato.trim() && !s.alimentacao && !s.acao && !s.ancora && s.sessoes.length === 0 && !s.bloco && !s.semana && !s.prEx && !s.prValor && !s.prCtx }
function snapEq(a: Snap, b: Snap) { return a.nivel === b.nivel && a.energia === b.energia && a.sono === b.sono && a.exercicio === b.exercicio && a.nota === b.nota && a.relato === b.relato && a.alimentacao === b.alimentacao && a.acao === b.acao && a.ancora === b.ancora && a.bloco === b.bloco && a.semana === b.semana && a.prOpen === b.prOpen && a.prEx === b.prEx && a.prTipo === b.prTipo && a.prValor === b.prValor && a.prCtx === b.prCtx && JSON.stringify(a.sessoes) === JSON.stringify(b.sessoes) }
function serverSnap(e?: Entrada, h?: Humor): Snap {
  return {
    nivel: h?.nivel ?? null,
    energia: h?.energia ?? null,
    sono: h?.sono_horas != null ? String(h.sono_horas) : '',
    exercicio: h?.exercicio_horas != null ? String(h.exercicio_horas) : '',
    nota: h?.nota || '',
    relato: e?.relato || '',
    alimentacao: e?.alimentacao || '',
    acao: e?.acao_do_dia || '',
    ancora: e?.ancora || '',
    // treino/PR não têm prefill do servidor (append): só rascunho restaura sessão em montagem
    bloco: '', semana: '', sessoes: [], prOpen: false, prEx: '', prTipo: '1RM', prValor: '', prCtx: '',
  }
}
const sameDay = (s: string, d: string) => (s || '').slice(0, 10) === d
// TreinoRow (do histórico) -> Sessao editável no form (mantém o id p/ o save virar UPDATE, não append)
function treinoToSessao(t: TreinoRow): Sessao {
  return {
    id: t.id,
    dia_tipo: t.dia_tipo || 'livre',
    exercicios: (t.exercicios || []).map(e => ({
      nome: e.nome || '',
      series: e.series != null ? String(e.series) : '',
      reps: e.reps || '',
      carga_kg: e.carga_kg != null ? String(e.carga_kg) : '',
      rpe: e.rpe != null ? String(e.rpe) : '',
    })),
    obs: t.observacoes || '',
    calorias: t.calorias != null ? String(t.calorias) : '',
  }
}

function Scale({ value, onChange, accent }: { value: number | null; onChange: (n: number) => void; accent: string }) {
  return (
    <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
      {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(n => (
        <button key={n} onClick={() => onChange(n)} style={{
          width: 32, height: 32, borderRadius: 8, cursor: 'pointer', fontSize: '0.78rem', fontWeight: 600,
          border: '1px solid ' + (value === n ? accent : 'var(--border)'),
          background: value === n ? accent : 'var(--bg2)', color: value === n ? '#0b0b0f' : 'var(--muted)', transition: 'all .12s',
        }}>{n}</button>
      ))}
    </div>
  )
}

const inputStyle: React.CSSProperties = { width: '100%', padding: '0.6rem 0.8rem', background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 8, color: 'var(--fg)', fontSize: '0.9rem', fontFamily: 'inherit', boxSizing: 'border-box' }
const labelStyle: React.CSSProperties = { display: 'block', fontSize: '0.72rem', color: 'var(--muted)', letterSpacing: '0.06em', textTransform: 'uppercase', marginBottom: '0.5rem', marginTop: '1.25rem' }
const numStyle: React.CSSProperties = { ...inputStyle, width: 90 }
const exNumStyle: React.CSSProperties = { ...inputStyle, padding: '0.45rem 0.4rem', fontSize: '0.82rem', textAlign: 'center' }

export default function Checkin() {
  const [date, setDate] = useState(todayStr())
  const [nivel, setNivel] = useState<number | null>(null)
  const [energia, setEnergia] = useState<number | null>(null)
  const [sono, setSono] = useState('')
  const [exercicio, setExercicio] = useState('')
  const [nota, setNota] = useState('')
  const [relato, setRelato] = useState('')
  const [alimentacao, setAlimentacao] = useState('')
  const [acao, setAcao] = useState('')
  const [ancora, setAncora] = useState('')
  // treino
  const [bloco, setBloco] = useState('')
  const [semana, setSemana] = useState('')
  const [sessoes, setSessoes] = useState<Sessao[]>([])
  // PR
  const [prOpen, setPrOpen] = useState(false)
  const [prEx, setPrEx] = useState('')
  const [prTipo, setPrTipo] = useState('1RM')
  const [prValor, setPrValor] = useState('')
  const [prCtx, setPrCtx] = useState('')
  // dados carregados — cache-first: o histórico já aparece no 1º paint, depois revalida.
  const cache = readCkCache()
  const [humor, setHumor] = useState<Humor[]>(cache?.humor || [])
  const [entradas, setEntradas] = useState<Entrada[]>(cache?.entradas || [])
  const [treinos, setTreinos] = useState<TreinoRow[]>(cache?.treinos || [])
  const [marcos, setMarcos] = useState<Marco[]>(cache?.marcos || [])
  const [loaded, setLoaded] = useState<boolean>(cache != null)
  const [saving, setSaving] = useState(false)
  const [msg, setMsg] = useState<string | null>(null)

  // controle do prefill/rascunho do dia
  const appliedFor = useRef<string | null>(null)   // dia cujos campos já foram populados
  const baseline = useRef<Snap>(BLANK_SNAP)        // o que carregou (server ou rascunho) p/ saber se o user divergiu
  const injectTreino = useRef<{ date: string; sessao: Sessao; bloco: number | null; semana: number | null } | null>(null) // treino clicado no histórico p/ editar
  const applySnap = (s: Snap) => {
    setNivel(s.nivel); setEnergia(s.energia); setSono(s.sono); setExercicio(s.exercicio)
    setNota(s.nota); setRelato(s.relato); setAlimentacao(s.alimentacao); setAcao(s.acao); setAncora(s.ancora)
    setBloco(s.bloco); setSemana(s.semana); setSessoes(s.sessoes)
    setPrOpen(s.prOpen); setPrEx(s.prEx); setPrTipo(s.prTipo); setPrValor(s.prValor); setPrCtx(s.prCtx)
    baseline.current = s
  }

  function load() {
    fetch('/ckapi/checkin?k=' + encodeURIComponent(CHECKIN_TOKEN))
      .then(r => { if (!r.ok) throw new Error('http ' + r.status); return r.json() })
      .then((d: { humor?: Humor[]; entradas?: Entrada[]; treinos?: TreinoRow[]; marcos?: Marco[]; partial?: boolean }) => {
        // resposta incompleta (Supabase deu hiccup) → NÃO sobrescreve; mantém o cache/estado atual.
        if (d && !d.partial) {
          setHumor(d.humor || []); setEntradas(d.entradas || []); setTreinos(d.treinos || []); setMarcos(d.marcos || [])
          writeCkCache(d)
        }
        setLoaded(true)
      }).catch(() => setLoaded(true))
  }
  useEffect(load, [])

  // prefill do dia: ao abrir / trocar de dia, popula os campos com o RASCUNHO local ou, na falta dele,
  // com o que já está salvo naquele dia. É isso que faz "abriu → o relato que eu tava escrevendo tá lá".
  useEffect(() => {
    const e = entradas.find(x => sameDay(x.data, date))
    const h = humor.find(x => sameDay(x.data, date))
    if (appliedFor.current !== date) {
      const draft = readDraft(date)
      let base = draft || serverSnap(e, h)
      if (injectTreino.current && injectTreino.current.date === date) {
        const it = injectTreino.current
        base = { ...base, sessoes: [it.sessao], bloco: it.bloco != null ? String(it.bloco) : base.bloco, semana: it.semana != null ? String(it.semana) : base.semana }
        injectTreino.current = null
      }
      applySnap(base)
      appliedFor.current = date
    } else if (snapEq(baseline.current, BLANK_SNAP) && (e || h) && !readDraft(date)) {
      // cache estava frio: mostramos vazio e o fetch trouxe o dia agora. Só preenche se o user não começou a digitar.
      const cur: Snap = { nivel, energia, sono, exercicio, nota, relato, alimentacao, acao, ancora, bloco, semana, sessoes, prOpen, prEx, prTipo, prValor, prCtx }
      if (snapBlank(cur)) applySnap(serverSnap(e, h))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [date, entradas, humor])

  // autosave do rascunho do dia — cada tecla persiste; sobrevive a fechar a aba sem salvar.
  useEffect(() => {
    if (appliedFor.current !== date) return
    const s: Snap = { nivel, energia, sono, exercicio, nota, relato, alimentacao, acao, ancora, bloco, semana, sessoes, prOpen, prEx, prTipo, prValor, prCtx }
    if (snapEq(s, baseline.current)) return       // ainda igual ao que carregou → não cria rascunho à toa
    if (snapBlank(s)) { clearDraft(date); return }
    writeDraft(date, s)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nivel, energia, sono, exercicio, nota, relato, alimentacao, acao, ancora, bloco, semana, sessoes, prOpen, prEx, prTipo, prValor, prCtx])

  // mutadores de sessão / exercício
  const addSessao = (tipo: string) => setSessoes(s => [...s, { dia_tipo: tipo, exercicios: STRENGTH.has(tipo) ? tplRows(tipo) : [], obs: '', calorias: '' }])
  const removeSessao = (i: number) => setSessoes(s => s.filter((_, idx) => idx !== i))
  const patchSessao = (i: number, patch: Partial<Sessao>) => setSessoes(s => s.map((x, idx) => idx === i ? { ...x, ...patch } : x))
  const addEx = (si: number) => setSessoes(s => s.map((x, idx) => idx === si ? { ...x, exercicios: [...x.exercicios, blankEx()] } : x))
  const removeEx = (si: number, ei: number) => setSessoes(s => s.map((x, idx) => idx === si ? { ...x, exercicios: x.exercicios.filter((_, j) => j !== ei) } : x))
  const patchEx = (si: number, ei: number, patch: Partial<ExRow>) => setSessoes(s => s.map((x, idx) => idx === si ? { ...x, exercicios: x.exercicios.map((e, j) => j === ei ? { ...e, ...patch } : e) } : x))

  // clicar num treino do histórico -> carrega ele no form (lá em cima) pra editar; save vira UPDATE (tem id)
  const editTreino = (t: TreinoRow) => {
    const day = (t.data || '').slice(0, 10)
    const sessao = treinoToSessao(t)
    if (day === date) {
      setSessoes([sessao])
      if (t.bloco_semana != null) setBloco(String(t.bloco_semana))
      if (t.semana_num != null) setSemana(String(t.semana_num))
    } else {
      injectTreino.current = { date: day, sessao, bloco: t.bloco_semana, semana: t.semana_num }
      setDate(day)
    }
    try { window.scrollTo({ top: 0, behavior: 'smooth' }) } catch { /* noop */ }
  }

  const hasStrength = sessoes.some(s => STRENGTH.has(s.dia_tipo))

  const dayOf = (s: string) => (s || '').slice(0, 10)
  const dh = humor.filter(h => dayOf(h.data) === date)
  const de = entradas.filter(e => dayOf(e.data) === date)
  const dtreinos = treinos.filter(t => dayOf(t.data) === date)
  const isToday = date === todayStr()
  const savedTxt = [
    dh.length ? `${dh.length} vital${dh.length > 1 ? 'is' : ''}` : '',
    de.length ? `${de.length} relato${de.length > 1 ? 's' : ''}` : '',
    dtreinos.length ? `${dtreinos.length} treino${dtreinos.length > 1 ? 's' : ''}` : '',
  ].filter(Boolean).join(' · ')

  async function submit() {
    const treinosPayload = sessoes.filter(s => s.dia_tipo).map(s => {
      const exercicios = s.exercicios.filter(e => e.nome.trim()).map(e => ({
        nome: e.nome.trim(), series: e.series ? parseInt(e.series) : null, reps: e.reps.trim() || null, carga_kg: num(e.carga_kg), rpe: num(e.rpe),
      }))
      const { rpe_medio, volume_total } = sessaoMetrics(s.exercicios)
      const strength = STRENGTH.has(s.dia_tipo)
      return {
        id: s.id,
        dia_tipo: s.dia_tipo,
        bloco_semana: strength && bloco ? parseInt(bloco) : null,
        semana_num: strength && semana ? parseInt(semana) : null,
        exercicios: exercicios.length ? exercicios : null,
        rpe_medio, volume_total,
        calorias: s.calorias ? parseInt(s.calorias) : null,
        observacoes: s.obs.trim() || null,
      }
    })
    const marcosPayload = (prEx.trim() && prValor) ? [{ exercicio: prEx.trim(), tipo: prTipo, valor: num(prValor), unidade: 'kg', contexto: prCtx.trim() || null }] : []

    if (nivel == null && !relato.trim() && !alimentacao.trim() && !sono && !exercicio && !treinosPayload.length && !marcosPayload.length) {
      setMsg('preenche algo (humor, sono, treino ou relato)'); return
    }
    setSaving(true); setMsg(null)
    try {
      const r = await fetch('/ckapi/checkin?k=' + encodeURIComponent(CHECKIN_TOKEN), {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ data: date, nivel, energia, sono_horas: sono, exercicio_horas: exercicio, nota, relato, alimentacao, acao_do_dia: acao, ancora, treinos: treinosPayload, marcos: marcosPayload }),
      })
      const d = await r.json()
      if (r.ok) {
        setMsg('✓ salvo')
        clearDraft(date)            // servidor virou a fonte do dia → descarta o rascunho local
        appliedFor.current = null   // força re-seed do dia com o valor recém-salvo (relato/vitais continuam na tela)
        setSessoes([]); setBloco(''); setSemana('')   // treino/PR são append → resetam
        setPrOpen(false); setPrEx(''); setPrTipo('1RM'); setPrValor(''); setPrCtx('')
        load()
      } else setMsg('erro: ' + (d.error || 'falhou'))
    } catch { setMsg('erro de rede') }
    setSaving(false)
  }

  return (
    <>
      <Header />
      <main style={{ maxWidth: 620, margin: '0 auto', padding: '3rem 1.5rem 6rem' }}>
        <motion.div {...fade(0)} style={{ marginBottom: '1.25rem' }}>
          <p style={{ fontSize: '0.75rem', color: 'var(--muted)', letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: '0.75rem' }}>Check-in diário</p>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '0.5rem' }}>
            <button onClick={() => setDate(shiftDay(date, -1))} style={navBtn} aria-label="dia anterior">←</button>
            <h1 style={{ fontSize: 'clamp(1.5rem, 5vw, 2.1rem)', fontWeight: 700, letterSpacing: '-0.03em', lineHeight: 1.1, minWidth: 150, textAlign: 'center' }}>
              {isToday ? 'Hoje' : fmtDay(date)}
            </h1>
            <button onClick={() => !isToday && setDate(shiftDay(date, 1))} disabled={isToday} style={{ ...navBtn, opacity: isToday ? 0.3 : 1, cursor: isToday ? 'not-allowed' : 'pointer' }} aria-label="próximo dia">→</button>
          </div>
          <p style={{ color: 'var(--muted)', fontSize: '0.85rem', textAlign: 'center' }}>
            {savedTxt ? `já registrado: ${savedTxt}` : (isToday ? 'como foi o dia?' : 'preencher esse dia')}
          </p>
        </motion.div>

        <motion.div {...fade(0.08)} style={{ background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 12, padding: '1.5rem' }}>
          <label style={{ ...labelStyle, marginTop: 0 }}>Humor (1–10)</label>
          <Scale value={nivel} onChange={setNivel} accent="#4ade80" />
          <label style={labelStyle}>Energia (1–10)</label>
          <Scale value={energia} onChange={setEnergia} accent="#fbbf24" />

          <div style={{ display: 'flex', gap: '1.5rem', flexWrap: 'wrap' }}>
            <div>
              <label style={labelStyle}>Sono (horas)</label>
              <input type="number" step="0.5" min="0" max="24" style={numStyle} value={sono} onChange={e => setSono(e.target.value)} placeholder="7.5" />
            </div>
            <div>
              <label style={labelStyle}>Exercício (horas)</label>
              <input type="number" step="0.25" min="0" max="12" style={numStyle} value={exercicio} onChange={e => setExercicio(e.target.value)} placeholder="1" />
            </div>
          </div>

          {/* ── TREINO ESTRUTURADO ── */}
          <label style={labelStyle}>Treino · toque pra adicionar sessão (academia + karatê = 2)</label>
          <div style={{ display: 'flex', gap: 5, flexWrap: 'wrap' }}>
            {TREINO_TIPOS.map(t => (
              <button key={t} onClick={() => addSessao(t)} style={{
                padding: '0.4rem 0.7rem', borderRadius: 8, cursor: 'pointer', fontSize: '0.8rem', fontWeight: 600, textTransform: 'capitalize',
                border: '1px solid var(--border)', background: 'var(--bg2)', color: 'var(--muted)',
              }}>+ {t}</button>
            ))}
          </div>

          {hasStrength && (
            <div style={{ display: 'flex', gap: '1rem', marginTop: '0.85rem' }}>
              <div>
                <label style={{ ...labelStyle, marginTop: 0 }}>Bloco (1–4)</label>
                <input type="number" min="1" max="4" style={{ ...numStyle, width: 70 }} value={bloco} onChange={e => setBloco(e.target.value)} placeholder="1" />
              </div>
              <div>
                <label style={{ ...labelStyle, marginTop: 0 }}>Semana</label>
                <input type="number" min="1" max="8" style={{ ...numStyle, width: 70 }} value={semana} onChange={e => setSemana(e.target.value)} placeholder="1" />
              </div>
            </div>
          )}

          {sessoes.map((s, si) => (
            <div key={si} style={{ marginTop: '0.85rem', padding: '0.9rem', background: 'rgba(244,114,182,0.05)', border: '1px solid rgba(244,114,182,0.25)', borderRadius: 10 }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '0.6rem' }}>
                <span style={{ fontWeight: 700, fontSize: '0.9rem', color: '#f472b6', textTransform: 'capitalize' }}>{s.dia_tipo}</span>
                <button onClick={() => removeSessao(si)} style={removeBtn} aria-label="remover sessão">remover</button>
              </div>

              {STRENGTH.has(s.dia_tipo) && (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', marginBottom: '0.6rem' }}>
                  {s.exercicios.map((e, ei) => (
                    <div key={ei} style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                      <input style={{ ...inputStyle, padding: '0.45rem 0.6rem', fontSize: '0.85rem' }} value={e.nome} onChange={ev => patchEx(si, ei, { nome: ev.target.value })} placeholder="exercício" />
                      <div style={{ display: 'flex', gap: 4 }}>
                        <input style={{ ...exNumStyle, width: 46 }} value={e.series} onChange={ev => patchEx(si, ei, { series: ev.target.value })} placeholder="sér" inputMode="numeric" />
                        <input style={{ ...exNumStyle, width: 70 }} value={e.reps} onChange={ev => patchEx(si, ei, { reps: ev.target.value })} placeholder="reps" />
                        <input style={{ ...exNumStyle, width: 64 }} value={e.carga_kg} onChange={ev => patchEx(si, ei, { carga_kg: ev.target.value })} placeholder="kg" inputMode="decimal" />
                        <input style={{ ...exNumStyle, width: 48 }} value={e.rpe} onChange={ev => patchEx(si, ei, { rpe: ev.target.value })} placeholder="rpe" inputMode="decimal" />
                        <button onClick={() => removeEx(si, ei)} style={{ ...removeBtn, width: 32, padding: 0, flexShrink: 0 }} aria-label="remover exercício">×</button>
                      </div>
                    </div>
                  ))}
                  <button onClick={() => addEx(si)} style={addExBtn}>+ exercício</button>
                </div>
              )}

              <input style={{ ...inputStyle, marginBottom: '0.4rem' }} value={s.obs} onChange={ev => patchSessao(si, { obs: ev.target.value })} placeholder={STRENGTH.has(s.dia_tipo) ? 'observações (ombro doendo, fiz metade…)' : 'o que foi? (ex: esteira 25min Z2, karatê leve)'} />
              <input type="number" step="10" min="0" max="5000" style={{ ...inputStyle, width: 110 }} value={s.calorias} onChange={ev => patchSessao(si, { calorias: ev.target.value })} placeholder="kcal" />
            </div>
          ))}

          {/* ── PR / MARCO ── */}
          {!prOpen ? (
            <button onClick={() => setPrOpen(true)} style={{ ...addExBtn, marginTop: '0.85rem' }}>🏆 registrar um PR (recorde)</button>
          ) : (
            <div style={{ marginTop: '0.85rem', padding: '0.9rem', background: 'rgba(251,191,36,0.06)', border: '1px solid rgba(251,191,36,0.3)', borderRadius: 10 }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '0.6rem' }}>
                <span style={{ fontWeight: 700, fontSize: '0.85rem', color: '#fbbf24' }}>🏆 PR / recorde</span>
                <button onClick={() => { setPrOpen(false); setPrEx(''); setPrValor(''); setPrCtx('') }} style={removeBtn}>cancelar</button>
              </div>
              <input style={{ ...inputStyle, marginBottom: '0.4rem' }} value={prEx} onChange={e => setPrEx(e.target.value)} placeholder="exercício (ex: Agachamento)" />
              <div style={{ display: 'flex', gap: 4, marginBottom: '0.4rem' }}>
                {PR_TIPOS.map(tp => (
                  <button key={tp} onClick={() => setPrTipo(tp)} style={{
                    flex: 1, padding: '0.45rem', borderRadius: 7, cursor: 'pointer', fontSize: '0.8rem', fontWeight: 600,
                    border: '1px solid ' + (prTipo === tp ? '#fbbf24' : 'var(--border)'), background: prTipo === tp ? '#fbbf24' : 'var(--bg2)', color: prTipo === tp ? '#0b0b0f' : 'var(--muted)',
                  }}>{tp}</button>
                ))}
              </div>
              <div style={{ display: 'flex', gap: 4 }}>
                <input type="number" step="2.5" style={{ ...inputStyle, width: 110 }} value={prValor} onChange={e => setPrValor(e.target.value)} placeholder="kg" inputMode="decimal" />
                <input style={{ ...inputStyle, flex: 1 }} value={prCtx} onChange={e => setPrCtx(e.target.value)} placeholder="contexto (opcional)" />
              </div>
            </div>
          )}

          <label style={labelStyle}>Nota do humor (opcional)</label>
          <input style={inputStyle} value={nota} onChange={e => setNota(e.target.value)} placeholder="ex: ansioso de manhã, melhorou à noite" />
          <label style={labelStyle}>Relato do dia</label>
          <textarea style={{ ...inputStyle, minHeight: 100, resize: 'vertical' }} value={relato} onChange={e => setRelato(e.target.value)} placeholder="o que rolou? o que pesou, o que foi bom…" />
          <label style={labelStyle}>Alimentação (só o que saiu do normal)</label>
          <input style={inputStyle} value={alimentacao} onChange={e => setAlimentacao(e.target.value)} placeholder="comeu normal? deixa vazio. besteira/doce/álcool/fora de hora? anota aqui" />
          <label style={labelStyle}>Ação pra amanhã (opcional)</label>
          <input style={inputStyle} value={acao} onChange={e => setAcao(e.target.value)} placeholder="1 coisa concreta" />
          <label style={labelStyle}>Âncora / frase do dia (opcional)</label>
          <input style={inputStyle} value={ancora} onChange={e => setAncora(e.target.value)} placeholder="algo pra lembrar" />

          <button onClick={submit} disabled={saving} style={{ marginTop: '1.5rem', width: '100%', padding: '0.85rem', borderRadius: 9, cursor: saving ? 'wait' : 'pointer', border: 'none', background: '#4ade80', color: '#0b0b0f', fontWeight: 700, fontSize: '0.95rem' }}>
            {saving ? 'salvando…' : (isToday ? 'Salvar check-in' : 'Salvar nesse dia')}
          </button>
          {msg && <p style={{ marginTop: '0.75rem', fontSize: '0.85rem', textAlign: 'center', color: msg.startsWith('✓') ? '#4ade80' : '#f87171' }}>{msg}</p>}
        </motion.div>

        {/* skeleton — só no 1º load de todos (sem cache ainda); depois o cache cobre */}
        {!loaded && treinos.length === 0 && humor.length === 0 && marcos.length === 0 && (
          <div style={{ marginTop: '2.5rem', display: 'flex', flexDirection: 'column', gap: '0.5rem' }} aria-hidden>
            {[0, 1, 2, 3].map(i => (
              <motion.div key={i} initial={{ opacity: 0.35 }} animate={{ opacity: [0.35, 0.65, 0.35] }} transition={{ duration: 1.2, repeat: Infinity, delay: i * 0.1 }}
                style={{ height: 42, borderRadius: 8, background: 'var(--bg2)', border: '1px solid var(--border)' }} />
            ))}
          </div>
        )}

        {/* histórico de treinos */}
        {treinos.length > 0 && (
          <motion.section {...fade(0.16)} style={{ marginTop: '2.5rem' }}>
            <h2 style={{ fontSize: '0.72rem', color: 'var(--muted)', letterSpacing: '0.12em', textTransform: 'uppercase', marginBottom: '0.85rem' }}>Treinos recentes</h2>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
              {treinos.slice(0, 12).map((t, i) => (
                <button key={i} onClick={() => editTreino(t)} title="editar esse treino lá em cima" style={{
                  display: 'flex', alignItems: 'baseline', gap: '0.65rem', padding: '0.6rem 0.9rem', background: 'var(--bg2)',
                  border: '1px solid ' + (dayOf(t.data) === date ? '#f472b6' : 'var(--border)'), borderRadius: 8, fontSize: '0.8rem', cursor: 'pointer', textAlign: 'left',
                }}>
                  <span style={{ fontFamily: 'monospace', color: 'var(--muted)', minWidth: 60, flexShrink: 0 }}>{fmtDay(dayOf(t.data))}</span>
                  <span style={{ color: '#f472b6', fontWeight: 700, textTransform: 'capitalize', flexShrink: 0 }}>{t.dia_tipo}</span>
                  <span style={{ color: 'var(--fg)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: 1 }}>{fmtTreino(t)}</span>
                  {t.rpe_medio != null && <span style={{ color: '#fbbf24', fontWeight: 600, flexShrink: 0 }}>RPE {t.rpe_medio}</span>}
                </button>
              ))}
            </div>
          </motion.section>
        )}

        {/* PRs */}
        {marcos.length > 0 && (
          <motion.section {...fade(0.2)} style={{ marginTop: '1.75rem' }}>
            <h2 style={{ fontSize: '0.72rem', color: 'var(--muted)', letterSpacing: '0.12em', textTransform: 'uppercase', marginBottom: '0.75rem' }}>🏆 PRs</h2>
            <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
              {marcos.slice(0, 12).map((m, i) => (
                <span key={i} style={{ padding: '0.4rem 0.7rem', background: 'rgba(251,191,36,0.1)', border: '1px solid rgba(251,191,36,0.35)', borderRadius: 8, fontSize: '0.78rem', color: 'var(--fg)' }}>
                  <strong>{m.exercicio}</strong> {m.tipo} {m.valor}{m.unidade || 'kg'}
                </span>
              ))}
            </div>
          </motion.section>
        )}

        {/* vitais */}
        {humor.length > 0 && (
          <motion.section {...fade(0.24)} style={{ marginTop: '1.75rem' }}>
            <h2 style={{ fontSize: '0.72rem', color: 'var(--muted)', letterSpacing: '0.12em', textTransform: 'uppercase', marginBottom: '0.85rem' }}>Últimos dias</h2>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
              {humor.slice(0, 10).map((h, i) => (
                <button key={i} onClick={() => setDate(dayOf(h.data))} style={{
                  display: 'flex', alignItems: 'center', gap: '0.8rem', padding: '0.55rem 0.9rem', background: 'var(--bg2)', border: '1px solid ' + (dayOf(h.data) === date ? '#4ade80' : 'var(--border)'),
                  borderRadius: 8, fontSize: '0.8rem', cursor: 'pointer', textAlign: 'left',
                }}>
                  <span style={{ fontFamily: 'monospace', color: 'var(--muted)', minWidth: 64 }}>{fmtDay(dayOf(h.data))}</span>
                  {h.nivel != null && <span style={{ color: '#4ade80', fontWeight: 600 }}>♥{h.nivel}</span>}
                  {h.energia != null && <span style={{ color: '#fbbf24', fontWeight: 600 }}>⚡{h.energia}</span>}
                  {h.sono_horas != null && <span style={{ color: '#60a5fa', fontWeight: 600 }}>☾{h.sono_horas}h</span>}
                  {h.exercicio_horas != null && <span style={{ color: '#f472b6', fontWeight: 600 }}>🏋{h.exercicio_horas}h</span>}
                  {h.nota && <span style={{ color: 'var(--muted)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{h.nota}</span>}
                </button>
              ))}
            </div>
          </motion.section>
        )}
      </main>
    </>
  )
}

const navBtn: React.CSSProperties = { width: 38, height: 38, borderRadius: 9, border: '1px solid var(--border)', background: 'var(--bg2)', color: 'var(--fg)', fontSize: '1.1rem', cursor: 'pointer', flexShrink: 0 }
const removeBtn: React.CSSProperties = { padding: '0.25rem 0.5rem', borderRadius: 6, border: '1px solid var(--border)', background: 'transparent', color: 'var(--muted)', fontSize: '0.72rem', cursor: 'pointer' }
const addExBtn: React.CSSProperties = { padding: '0.5rem', borderRadius: 7, border: '1px dashed var(--border)', background: 'transparent', color: 'var(--muted)', fontSize: '0.82rem', cursor: 'pointer', width: '100%' }
